import { backend } from "src/api";

class GroupApi {
  async getRegionGroups() {
    const response = await backend.get("/groups/region");
    return response.data;
  }

  async createRegionGroup(dto) {
    const response = await backend.post("/groups/region", dto);
    return response.data;
  }

  async deleteRegionGroup(id) {
    const response = await backend.delete(`/groups/region/${id}`);
    return response.data;
  }

  async updateRegionGroup(dto) {
    const response = await backend.put("/groups/region", dto);
    return response.data;
  }

  // =====================
  // AptFilter APIs
  // =====================

  async getAptFilters() {
    const response = await backend.get("/groups/apt-filter");
    return response.data;
  }

  async createAptFilter(dto) {
    const response = await backend.post("/groups/apt-filter", dto);
    return response.data;
  }

  async deleteAptFilter(id) {
    const response = await backend.delete(`/groups/apt-filter/${id}`);
    return response.data;
  }

  async updateAptFilter(dto) {
    const response = await backend.put("/groups/apt-filter", dto);
    return response.data;
  }

  // =====================
  // AptGroup APIs
  // =====================

  async getAptGroups() {
    const response = await backend.get("/groups/apt-group");
    return response.data;
  }

  async createAptGroup(dto) {
    const response = await backend.post("/groups/apt-group", dto);
    return response.data;
  }

  async deleteAptGroup(id) {
    const response = await backend.delete(`/groups/apt-group/${id}`);
    return response.data;
  }

  async updateAptGroup(dto) {
    const response = await backend.put("/groups/apt-group", dto);
    return response.data;
  }
}

export const groupApi = new GroupApi();
